if (!customElements.get('section-look')) {
  class SectionLook extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.footerButton = this.querySelector('.c-look__footer .m-button');
      this.footerButtonText = this.querySelector('.c-look__footer-button-text');
      if (!this.footerButton) return;

      this.productCards = this.querySelectorAll('.c-look-card');
      this.originalButtonText = this.footerButtonText ? this.footerButtonText.innerText.trim() : this.footerButton.innerText.trim();
      this.cart = document.querySelector('m-cart-drawer');

      this.init();
    }

    init() {
      // Listen for changes
      this.addEventListener('change', (e) => {
        if (e.target.matches('input[type="radio"]')) {
          this.updateTotal();
        }
      });

      // Prevent card link click when clicking on sizes
      const sizeSelectors = this.querySelectorAll('.c-look-card__sizes');
      sizeSelectors.forEach(selector => {
        selector.addEventListener('click', (e) => {
          // No longer needed as the parent is not an <a> tag
          // but kept for safety if there are other nested links
          e.stopPropagation();
        });
      });

      // Click event
      this.footerButton.addEventListener('click', this.handleButtonClick.bind(this));

      // Initial update
      this.updateTotal();
    }

    updateTotal() {
      let totalPrice = 0;
      let allSelected = true;

      this.productCards.forEach(card => {
        const selectedOption = card.querySelector('input[type="radio"]:checked');
        const hasSizes = !!card.querySelector('.c-look-card__sizes');

        if (selectedOption) {
          const priceNode = selectedOption.closest('.m-product-option--node');
          if (priceNode && priceNode.dataset.price) {
            totalPrice += parseInt(priceNode.dataset.price);
          }
        } else {
          // If no radio is checked
          if (!hasSizes && card.dataset.defaultPrice) {
            // Product without size options
            totalPrice += parseInt(card.dataset.defaultPrice);
          } else {
            // Product with sizes but none selected (or all sold out)
            allSelected = false;
          }
        }
      });

      if (allSelected && totalPrice > 0) {
        const formattedPrice = window.formatMoney ? window.formatMoney(totalPrice, window.MinimogSettings?.money_format) : (totalPrice / 100).toFixed(2);
        const text = `${this.originalButtonText} | ${formattedPrice}`;
        if (this.footerButtonText) {
          this.footerButtonText.innerText = text;
        } else {
          this.footerButton.innerText = text;
        }
      } else {
        if (this.footerButtonText) {
          this.footerButtonText.innerText = this.originalButtonText;
        } else {
          this.footerButton.innerText = this.originalButtonText;
        }
      }
    }

    async handleButtonClick(e) {
      e.preventDefault();

      const items = [];
      this.productCards.forEach(card => {
        const selectedOption = card.querySelector('input[type="radio"]:checked');
        const hasSizes = !!card.querySelector('.c-look-card__sizes');

        if (selectedOption) {
          const variantNode = selectedOption.closest('.m-product-option--node');
          if (variantNode && variantNode.dataset.variantId) {
            items.push({
              id: parseInt(variantNode.dataset.variantId),
              quantity: 1
            });
          }
        } else if (!hasSizes && card.dataset.defaultVariantId) {
          // Product without sizes, add default variant
          items.push({
            id: parseInt(card.dataset.defaultVariantId),
            quantity: 1
          });
        }
      });

      if (items.length > 0) {
        this.footerButton.classList.add('m-spinner-loading');
        
        const sections = this.cart ? this.cart.getSectionsToRender().map((s) => s.id) : [];
        const body = JSON.stringify({
          items,
          sections: sections.join(','),
          sections_url: window.location.pathname
        });

        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: body
          });

          const data = await response.json();

          if (response.ok) {
            if (this.cart && window.MinimogSettings?.enable_cart_drawer) {
              this.cart.renderContents(data);
              
              if (window.MinimogTheme?.Notification) {
                window.MinimogTheme.Notification.show({
                  target: this.cart.querySelector('m-cart-drawer-items') || this.cart,
                  method: 'prepend',
                  type: 'success',
                  message: window.MinimogStrings.itemAdded,
                  delay: 400
                });
              }
            } else {
              if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents) {
                window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, data);
                window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.openCartDrawer);
              }

              if (window.MinimogTheme?.Notification) {
                window.MinimogTheme.Notification.show({
                  target: document.body,
                  method: 'appendChild',
                  type: 'success',
                  message: window.MinimogStrings.itemAdded,
                  last: 3000
                });
              }
            }
          } else {
            if (window.MinimogTheme?.Notification) {
              window.MinimogTheme.Notification.show({
                target: document.body,
                method: 'appendChild',
                type: 'warning',
                message: data.description || data.message || 'Error adding to cart',
                last: 3000
              });
            } else {
              alert(data.description || data.message || 'Error adding to cart');
            }
          }
        } catch (err) {
          console.error('Error adding to cart:', err);
        } finally {
          this.footerButton.classList.remove('m-spinner-loading');
        }
      }
    }
  }

  customElements.define('section-look', SectionLook);
}
